var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('v-container',{attrs:{"pa-0":"","fluid":"","fill-height":"","align-content-center":"","align-center":""}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }